import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app" }

import NavbarComponent from "@/components/NavbarComponent.vue";
import {onMounted, onUnmounted, ref, watch} from "vue";
import SidebarComponent from "@/components/SidebarComponent.vue";
import FooterImpressum from "./components/FooterImpressum.vue";
import "@/assets/styles/main.css"
import {useRoute} from "vue-router";

const siteName = "KFZ Musterwerkstatt";
const fallbackDescription = "KFZ Musterwerkstatt in Musterstadt: Kfz-Werkstatt für Inspektion, Wartung, Reparatur, Diagnose, Reifenservice und Klimaservice.";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const setMeta = (selector: string, attribute: "name" | "property", key: string, content: string) => {
  let element = document.head.querySelector<HTMLMetaElement>(selector);

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
};

const setCanonical = (href: string) => {
  let element = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');

  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    document.head.appendChild(element);
  }

  element.setAttribute("href", href);
};

watch(
    () => route.fullPath,
    () => {
      const title = route.meta.title as string || siteName;
      const description = route.meta.description as string || fallbackDescription;
      const canonical = `${window.location.origin}${route.path}`;

      document.title = title;
      setMeta('meta[name="description"]', "name", "description", description);
      setMeta('meta[property="og:title"]', "property", "og:title", title);
      setMeta('meta[property="og:description"]', "property", "og:description", description);
      setMeta('meta[property="og:url"]', "property", "og:url", canonical);
      setMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
      setMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
      setCanonical(canonical);
    },
    {immediate: true}
);

const isMobile = ref(window.innerWidth <= 768);

const handleResize = () => {
  isMobile.value = window.innerWidth <= 768;
};

onMounted(() => window.addEventListener("resize", handleResize));
onUnmounted(() => window.removeEventListener("resize", handleResize));


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isMobile.value)
      ? (_openBlock(), _createBlock(NavbarComponent, { key: 0 }))
      : (_openBlock(), _createBlock(SidebarComponent, { key: 1 })),
    _createVNode(_component_router_view),
    _createVNode(FooterImpressum)
  ]))
}
}

})